import {ThreadArtifactResult} from '../types';

export interface GeneratedImageArtifact {
    /** Present when the generated image is served from a protected URL. */
    artifact?: ThreadArtifactResult;
    /** Present (as a full `data:` URL) when the image is inline base64. */
    base64DataUrl?: string;
    fileName: string;
}

/**
 * Resolves a generated image (from the image-generation tool) out of a
 * message's metadata, normalising the URL-based and base64 cases. Returns
 * `null` when the message has no generated image.
 */
export default function getGeneratedImageArtifact(
    metadata?: Record<string, string>
): GeneratedImageArtifact | null {
    if (!metadata) {
        return null;
    }

    const base64 = metadata.generated_image_b64;
    const artifactUrl = metadata.ig_artifact_url;
    const generatedImageId = metadata.ig_id;
    const threadArtifactId = metadata.ig_thread_artifact_id;
    const fileName =
        metadata.ig_file_name || `${generatedImageId || 'generated-image'}.png`;

    if (artifactUrl && threadArtifactId) {
        return {
            artifact: {
                thread_artifact_id: threadArtifactId,
                artifact_url: artifactUrl,
                file_name: fileName,
                file_download_markdown: `[${fileName}](${artifactUrl})`,
                is_error: false
            },
            fileName
        };
    }

    if (base64) {
        return {
            base64DataUrl: `data:image/png;base64,${base64}`,
            fileName
        };
    }

    return null;
}
